const initModal = () => {
  const modals = document.querySelectorAll(".modal");
  const openButtons = document.querySelectorAll(".open-modal");
  const closeButtons = document.querySelectorAll(".modal__close");

  // Open modal
  openButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      const modalId = button.getAttribute("data-modal");
      const modal = document.getElementById(modalId);

      modal.showModal();
    });
  });

  // Close modal
  closeButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      const modalId = button.getAttribute("data-modal");

      const modal = document.getElementById(modalId);
      modal.close();
    });
  });

  // Close on outside click
  modals.forEach((modal) => {
    modal.addEventListener("click", (e) => {
      const dialogDimensions = modal.getBoundingClientRect();
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        modal.close();
      }
    });
  });
};

export default initModal;
